import { getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, request, services } from '@/utils'

import { invoiceStatues, statusColors } from '@/components/services/invoices/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(services.invoices)

export default {
  name: 'ButtonsModeration',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    view: {
      type: String,
      default: 'item',
      validator: value => {
        return ~[ 'item', 'form' ].indexOf(value)
      }
    },

    status: {
      type: String,
      default: 'paid',
      validator: value => {
        return invoiceStatues.includes(value)
      }
    }
  },

  data() {
    return {
      loading: {
        paid: false,
        rejected: false
      },

      showDialog: false
    }
  },

  computed: {
    isLoading() {
      for (const key in this.loading) {
        if (this.loading[key]) {
          return true
        }
      }

      return false
    }
  },

  methods: {
    async update() {
      if (~[ invoiceStatues.paid, invoiceStatues.rejected ].indexOf(invoiceStatues[this.status])) {
        try {
          this.loading[this.status] = true
          const data = await request.update(joinURLPath(pathToAPI, this.value.id), { body: { status: this.status } })
          if (data.status === this.status) {
            this.addSnackbar({
              text: this.getTranslate(`${services.invoices}.snackbars.${this.status}`),
              type: statusColors[this.status]
            })
          }
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          this.loading[this.status] = false
          this.showDialog = false
        }
      }
    }
  },

  render
}
